module.exports = __webpack_public_path__ + "static/jinx_960w_q50-a5ecdc02314198e778ebf70480422fae.webp";